import styled from 'styled-components';

import { Section, Copy } from '@belong/ui-components';
import { media } from '@belong/themes';

export const StyledSection = styled(Section)`
  & + .contentSection {
    border-top: 4rem solid rgba(0, 0, 0, 0);
    ${media('md')`
        border-top-width: 4.8rem;
    `}
  }
`;

export const StyledCopy = styled(Copy)`
  position: relative;
  padding-left: 3rem;
  margin-bottom: 1.6rem;

  ${media('md')`
    margin-bottom: 2.4rem;
  `}

  .inline-icon {
    position: absolute;
    top: 0;
    left: 0;
  }

  .regional-countries-list {
    margin: 2rem 0;
  }
`;

export const StyledList = styled.ul`
  margin: 1rem 0 0 3rem;
`;

export const StyledListItem = styled.li`
  list-style-type: none;

  ${StyledCopy} {
    display: flex;
    align-items: center;
    padding-left: 0;
    margin-bottom: 0;

    .inline-icon {
      position: relative;
      margin-right: 1rem;
    }
  }
`;
